import axios, { AxiosRequestHeaders } from "axios";
import { useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";

export const usersActiveSubscriptionGet: IApiFetcher = async ({
  utoken,
  omitUserAgent = false,
}: {
  utoken: string;
  omitUserAgent?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const response = await axios.get<any>(`${HOSTNAME}${usersActiveSubscriptionGet.url}`, {
    headers,
  });
  return response.data;
};
usersActiveSubscriptionGet.url = "/wp-json/wp/v3/users/active-subscription";
usersActiveSubscriptionGet.method = 'GET';

const UsersActiveSubscription: ApiTesterComponent = ({
  loginData,
}: {
  loginData: ILoginData2 | null;
}) => {
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(false);

  const onFetch = () => {
    if (!loginData?.token) return;

    setIsLoading(true);
    usersActiveSubscriptionGet({
      utoken: loginData.token,
      omitUserAgent: true,
    }).then((data) => {
      setIsLoading(false);
      setData(JSON.stringify(data, null, 2));
    });
  };

  return (
    <div>
      <h3>UsersActiveSubscription</h3>

      <button onClick={onFetch}>Fetch</button>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

UsersActiveSubscription.fetcher = usersActiveSubscriptionGet;

export default UsersActiveSubscription;
